import { readS3File } from "./ResourcesService";

export default async function ResourceInitData(initDataKey: string): Promise<any> {
    const key = `data/${initDataKey}.json`;
    const initDataFile = await readS3File(key);

    return initDataFile;
}
